export default __webpack_public_path__ + "static/media/banner3.0d592a24.jpg";